import React, { Fragment, memo } from 'react';
import ReactMarkDown from 'react-markdown';
import styles from './description.module.scss';

export const Description = memo(({text}:{text:string}) => {
	return <ReactMarkDown
    source={text}
    className={styles.description}
    escapeHtml={false}
    renderers={{ paragraph: props => <Fragment children={props.children} /> }}
  />
});